// Global
import '../../../js/app.js';
import '../../../scss/styles.scss';

// Home
import './single.js';
import './single.scss';
